module.exports = __webpack_public_path__ + "product.variation-selector-8629c3e7.html";